export const PARENT_SLICE_NAME = 'scheduleBuilderSchedule' as const;
export const SLICE_NAME = 'timeOffBlackoutPeriods' as const;

export const RELATIONSHIP_TYPES = {
  SCHEDULE: 'schedule',
  TIME_OFF: 'time_off',
} as const;
